<template>
  <div>
    <base-header type="gradient-warning" class="pb-6 pb-8 pt-5 pt-md-8">
      <div
        class="container-fluid d-flex align-items-center justify-content-between"
      >
        <p class="text-white mt-3">
          Aqui você pode gerenciar o networking secreto dos investidores
        </p>
        <base-button @click="$router.push('networking-secreto-startups')">
          Trocar para modo Startup
        </base-button>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div class="card shadow table-container vld-parent">
        <header
          class="card-header border-0 row no-gutters justify-content-between"
        >
          <div class="col-sm-4 row no-gutters align-items-center">
            <h3 class="col mr-2">Fundo:</h3>
            <select class="form-control col-6" v-model="selectedFund">
              <option value="" selected disabled>Selecione uma opção</option>
              <option v-for="fund in funds" :key="fund.tag" :value="fund">
                {{ fund.tag }}
              </option>
            </select>
          </div>
          <div class="col-sm-4 row no-gutters align-items-center">
            <h3 class="col mr-2">Rodada:</h3>
            <select
              class="form-control col-6"
              v-model="selectedFund.selectedRound"
              :disabled="!selectedFund"
            >
              <option :value="undefined" selected disabled>
                Selecione uma opção
              </option>

              <option v-show="isNewRound" :value="lastRound + 1">
                {{ lastRound + 1 }}
              </option>

              <option
                v-for="round in lastRound"
                :key="'round_' + round"
                :value="lastRound - round + 1"
              >
                {{ lastRound - round + 1 }}
              </option>
            </select>
          </div>
          <base-button
            :disabled="isNewRoundDisabled()"
            class="col- px-2"
            type="primary"
            size="sm"
            :custom="true"
            @click="handleNewRound"
            >Criar novo round</base-button
          >
        </header>
        <main
          class="border-top border-dark row no-gutters"
          style="min-height: 60dvh"
        >
          <section class="col-sm-4 col-xxl-3 border-right border-dark">
            <h4 class="text-center my-1">
              Participantes
              <span v-if="selectedFund.investidores"
                >({{ selectedFund.investidores.length }})</span
              >
            </h4>
            <div
              v-if="selectedFund"
              class="row no-gutters text-center m-1 pb-1 overflow-auto"
              style="height: 70dvh"
            >
              <div
                v-for="participant in selectedFund.investidores"
                :key="'participant_' + participant.pivot.id"
                class="col-xl-6"
              >
                <div class="border rounded m-1 bg-lighter">
                  <img
                    class="card-image my-2"
                    :src="
                      participant.profilePicture
                        ? participant.profilePicture.url
                        : defaultImage
                    "
                    :alt="`foto de perfil de ${participant.name} `"
                  />
                  <p class="p-0 m-0">{{ participant.name }}</p>
                  <p class="p-0 m-0">
                    <i class="fas fa-briefcase mr-1"></i>
                    {{ participant.working_place || "-" }}
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section class="col-sm-8 col-xxl-9 px-1 d-flex flex-column">
            <h4 class="text-center mt-1">
              {{ isNewRound ? "Pré-Visualizar" : "" }}
              Matches
              <span v-if="selectedFund.selectedRound">
                ({{ matches.length }})</span
              >
            </h4>
            <div
              v-if="selectedFund && selectedFund.selectedRound"
              class="text-center d-flex flex-column"
              style="height: 70dvh"
            >
              <div>
                <span>
                  <i class="fas fa-square text-success"></i>
                  match normal
                </span>
                <span class="mx-2">
                  <i class="fas fa-square text-attention"></i>
                  match forçado </span
                ><span>
                  <i class="fas fa-square text-danger"></i>
                  match inválido
                </span>
              </div>
              <div class="row no-gutters my-1 overflow-auto">
                <div
                  v-for="(match, index) in matches"
                  :key="'match_' + index"
                  class="col-lg-6 col-xxl-4 col-xxxl-3"
                >
                  <div
                    class="row no-gutters rounded border m-1"
                    style="border-width: 3px !important"
                    :class="getMatchStatus(match)"
                  >
                    <div class="col">
                      <img
                        class="card-image my-2"
                        :src="
                          getValue(
                            match.left_participant_id,
                            'profilePicture'
                          ) || defaultImage
                        "
                        :alt="getValue(match.left_participant_id, 'name')"
                      />
                      <p class="mb-1">
                        {{ getValue(match.left_participant_id, "name") }}
                      </p>
                    </div>
                    <div class="col">
                      <img
                        class="card-image my-2"
                        :src="
                          getValue(
                            match.right_participant_id,
                            'profilePicture'
                          ) || defaultImage
                        "
                        :alt="getValue(match.right_participant_id, 'name')"
                      />
                      <p class="mb-0">
                        {{ getValue(match.right_participant_id, "name") }}
                      </p>
                    </div>
                    <div v-if="isNewRound" class="">
                      <span
                        class="btn p-1 cursor-pointer"
                        @click="handleRemoveMatch(index)"
                        ><i class="fas fa-minus-square fa-lg text-red"></i
                      ></span>
                    </div>
                    <div class="col-12 text-center my-2">
                      <span v-if="match.meetingsCounter">
                        <b>número reuniões passadas:</b>
                        {{ match.meetingsCounter }}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="isNewRound && participants.length"
                  class="col-lg-6 col-xxl-4 col-xxxl-3"
                >
                  <div
                    class="row no-gutters rounded border m-1 justify-content-center"
                    style="border-width: 3px !important"
                    :class="'border-attention'"
                  >
                    <div class="col-6">
                      <img
                        class="card-image my-2"
                        :src="
                          getValue(
                            forcedMatch.left_participant_id,
                            'profilePicture'
                          ) || defaultImage
                        "
                        alt="image placeholder"
                      />
                      <div class="mx-2">
                        <select
                          class="form-control form-control-sm"
                          v-model="forcedMatch.left_participant_id"
                        >
                          <option :value="0" selected disabled>
                            Selecione
                          </option>
                          <option
                            v-for="participant in participants"
                            :key="'left_participant' + participant.user_id"
                            :value="participant.user_id"
                            :disabled="
                              participant.user_id ===
                              forcedMatch.right_participant_id
                            "
                          >
                            {{ participant.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-6">
                      <img
                        class="card-image my-2"
                        :src="
                          getValue(
                            forcedMatch.right_participant_id,
                            'profilePicture'
                          ) || defaultImage
                        "
                        alt="image placeholder"
                      />
                      <div class="mx-2">
                        <select
                          class="form-control form-control-sm"
                          v-model="forcedMatch.right_participant_id"
                        >
                          <option :value="0" selected disabled>
                            Selecione
                          </option>
                          <option
                            v-for="participant in participants"
                            :key="'right_participant' + participant.user_id"
                            :value="participant.user_id"
                            :disabled="
                              participant.user_id ===
                              forcedMatch.left_participant_id
                            "
                          >
                            {{ participant.name }}
                          </option>
                          <option disabled>--- STARS ---</option>
                          <option
                            v-for="collaborator in stars"
                            :key="'collaborator_' + collaborator.user_id"
                            :value="collaborator.user_id"
                          >
                            {{ collaborator.investor.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div @click="handleAddMatch" class="mt-2 mb-1">
                      <base-button
                        size="sm"
                        :disabled="
                          !forcedMatch.left_participant_id ||
                          !forcedMatch.right_participant_id
                        "
                      >
                        adicionar</base-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isNewRound" class="pb-2 mt-auto">
                <base-checkbox v-model="acceptRepeated" class="mb-1">
                  Aceitar reuniões repetidas
                </base-checkbox>

                <base-button @click="handlePreviewMatches"
                  >Pré-visualizar Matches</base-button
                >
                <base-button
                  @click="handleStoreMatches"
                  :disabled="participants.length !== 0"
                  >Salvar Matches</base-button
                >
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  name: "networking-secreto-admin",
  data() {
    return {
      funds: [],
      selectedFund: "",
      participantsMap: {},
      previewMatches: [],
      forcedMatch: {
        left_participant_id: 0,
        right_participant_id: 0,
        is_forced: true,
      },
      acceptRepeated: false,
      stars: [],
      defaultImage: "/img/pages/default_profile_picture.png",
    };
  },
  computed: {
    lastRound() {
      if (!this.selectedFund) return undefined;
      if (!this.selectedFund.round) return 0;
      return this.selectedFund.round.round_number;
    },
    isNewRound() {
      return this.selectedFund.selectedRound === this.lastRound + 1;
    },
    matches() {
      const { matches, selectedRound } = this.selectedFund;

      if (!matches) return undefined;
      if (this.isNewRound) return this.previewMatches;

      return matches.filter((m) => m.round_number === selectedRound);
    },
    participants() {
      const { investidores } = this.selectedFund;

      if (!investidores) return undefined;

      const usedIds = this.previewMatches.flatMap((pm) => [
        pm.left_participant_id,
        pm.right_participant_id,
      ]);

      const participants = investidores.filter(
        ({ user_id }) => !usedIds.includes(user_id)
      );

      return participants;
    },
  },

  async mounted() {
    await this.loadFunds();
    await this.loadStars();
  },

  methods: {
    async loadFunds() {
      let loader = this.$loading.show({
        width: 90,
        height: 90,
      });

      try {
        const { data } = await api.get("networking/funds");
        this.funds = data;

        for (const { investidores } of data) {
          for (const { pivot, ...investor } of investidores) {
            if (!this.participantsMap[pivot.investor_id])
              this.participantsMap[pivot.investor_id] = investor;
          }
        }
      } catch (error) {
        this.$toasted.error("Ocorreu um erro ao recuperar informações");
      }
      loader.hide();
    },

    async loadStars() {
      let loader = this.$loading.show({
        width: 90,
        height: 90,
      });

      try {
        const { data } = await api.get("adm/stars");

        this.stars = data;

        for (const collaborator of data)
          if (!this.participantsMap[collaborator.user_id])
            this.participantsMap[collaborator.user_id] = collaborator.investor;
      } catch (error) {
        this.$toasted.error("Ocorreu um erro ao recuperar informações");
      }

      loader.hide();
    },

    async handlePreviewMatches() {
      let loader = this.$loading.show({
        width: 90,
        height: 90,
      });

      try {
        const { data } = await api.post("/networking/preview-matches", {
          fundId: this.selectedFund.id,
          definedMatches: this.previewMatches,
        });

        this.previewMatches = data;
      } catch (error) {
        this.$toasted.error("Ocorreu um erro ao gerar matches");
      }

      loader.hide();
    },

    async handleStoreMatches() {
      let loader = this.$loading.show({
        width: 90,
        height: 90,
      });

      try {
        const { data } = await api.post("/networking/matches", {
          fundId: this.selectedFund.id,
          matches: this.previewMatches,
          acceptRepeated: this.acceptRepeated,
        });

        const matches = [...data, ...this.selectedFund.matches];

        this.$set(this.selectedFund, "matches", matches);
        this.selectedFund.round = Object.assign({}, this.selectedFund.round, {
          round_number: this.selectedFund.selectedRound,
        });

        this.previewMatches = [];

        this.$toasted.success("Rodada criada com sucesso");
      } catch (error) {
        if (error.response.status === 400) {
          this.previewMatches = error.response.data.matches;
          this.hasError = true;
          return this.$toasted.error(
            "Um ou mais conflitos encontrados ao tentar salvar os matches"
          );
        }
        this.$toasted.error("Ocorreu um erro ao gerar matches");
      } finally {
        loader.hide();
      }
    },

    handleNewRound() {
      if (!this.selectedFund) return;

      this.$set(this.selectedFund, "selectedRound", this.lastRound + 1);
    },

    handleAddMatch() {
      this.previewMatches.push(this.forcedMatch);

      this.forcedMatch = {
        left_participant_id: 0,
        right_participant_id: 0,
        is_forced: true,
      };
    },

    handleRemoveMatch(index) {
      return this.previewMatches.splice(index, 1);
    },

    getValue(participantId, key) {
      if (!participantId) return null;

      const value = this.participantsMap[participantId][key];

      if (!value) return null;

      return key === "profilePicture" ? value.url : value;
    },

    getMatchStatus({ is_forced, meetingsCounter }) {
      if (meetingsCounter && !this.acceptRepeated) return "border-danger";
      if (is_forced) return "border-attention";
      return "border-success";
    },
    isNewRoundDisabled() {
      if (!this.selectedFund || this.isNewRound) return true;

      if (!this.selectedFund.round) return false;

      return false;
      // const lastRound = this.moment(this.selectedFund.round.created_at);
      // const diffMonths = this.moment().diff(lastRound, "months");

      // return diffMonths > 0;
    },
  },
};
</script>

<style scoped>
.card-image {
  width: 100px;
  height: 100px;
  border-radius: 10%;
  margin: auto;
}

.cursor-pointer {
  cursor: pointer;
}

img {
  object-fit: cover;
}
</style>
